(function () {
  var SECTION_SELECTOR = '.oddit-section-comparison-grid';
  var ATC_SELECTOR = '[data-oddit-comparison-atc]';
  // When data-pdp-sync is set, the highlighted CTA mirrors the current
  // product's variant — read the live variant id from the main PDP ATC at
  // click time so it tracks the shopper's selection.
  var PDP_ATC_SELECTOR = '.oddit-section-main-product__add-to-cart[data-variant-id]';

  function resolveVariantId(btn) {
    if (btn.getAttribute('data-pdp-sync') === 'true') {
      var pdpBtn = document.querySelector(PDP_ATC_SELECTOR);
      if (pdpBtn) {
        var live = Number(pdpBtn.getAttribute('data-variant-id'));
        if (live) return live;
      }
    }
    return Number(btn.getAttribute('data-variant-id')) || null;
  }

  function handleClick(e) {
    var btn = e.target.closest(ATC_SELECTOR);
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var variantId = resolveVariantId(btn);
    if (!variantId) return;

    if (!window.OdditCartDrawer || typeof window.OdditCartDrawer.addToCart !== 'function') {
      return;
    }

    var originalText = btn.getAttribute('data-original-text') || btn.textContent;
    var pendingText = btn.getAttribute('data-pending-text') || 'Adding…';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    btn.textContent = pendingText;

    window.OdditCartDrawer.addToCart(variantId, 1)
      .then(function () {
        if (typeof window.OdditCartDrawer.open === 'function') {
          window.OdditCartDrawer.open();
        }
      })
      .catch(function () {
        /* leave error reporting to OdditCartDrawer; just restore button below */
      })
      .then(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
      });
  }

  function initSection(section) {
    if (!section || section.__odditComparisonGridInit) return;
    section.__odditComparisonGridInit = true;
    section.addEventListener('click', handleClick);
  }

  function initAll() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector
      ? e.target.querySelector(SECTION_SELECTOR)
      : null;
    if (section) initSection(section);
  });
})();
